"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateApiKeyResponseSchema = exports.CreateApiKeyRequestSchema = exports.AdminApiKeysResponseSchema = exports.AdminApiKeySchema = exports.ApiKeyActorSchema = exports.ApiKeyStatusSchema = void 0;
const zod_1 = require("zod");
exports.ApiKeyStatusSchema = zod_1.z.enum(['active', 'revoked']);
exports.ApiKeyActorSchema = zod_1.z.object({ id: zod_1.z.uuid(), name: zod_1.z.string() });
exports.AdminApiKeySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    name: zod_1.z.string(),
    /** First 12 characters of the secret (`ccex_` + 7), enough to tell keys apart. */
    prefix: zod_1.z.string(),
    status: exports.ApiKeyStatusSchema,
    createdAt: zod_1.z.iso.datetime(),
    createdBy: exports.ApiKeyActorSchema,
    lastUsedAt: zod_1.z.iso.datetime().nullable(),
    revokedAt: zod_1.z.iso.datetime().nullable(),
    revokedBy: exports.ApiKeyActorSchema.nullable(),
});
exports.AdminApiKeysResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.AdminApiKeySchema) });
exports.CreateApiKeyRequestSchema = zod_1.z.object({ name: zod_1.z.string().trim().min(1).max(64) });
/** `secret` is returned exactly once; the server keeps only its hash. */
exports.CreateApiKeyResponseSchema = zod_1.z.object({
    apiKey: exports.AdminApiKeySchema,
    secret: zod_1.z.string(),
});
//# sourceMappingURL=api-keys.js.map